export var MPAOperationScope;
(function (MPAOperationScope) {
    MPAOperationScope["MPA_OPERATION_SCOPE_UNSPECIFIED"] = "MPA_OPERATION_SCOPE_UNSPECIFIED";
    MPAOperationScope["MPA_OPERATION_SCOPE_BACKUP_POLICY"] = "MPA_OPERATION_SCOPE_BACKUP_POLICY";
    MPAOperationScope["MPA_OPERATION_SCOPE_CLOUD_RESOURCE"] = "MPA_OPERATION_SCOPE_CLOUD_RESOURCE";
    MPAOperationScope["MPA_OPERATION_SCOPE_SNAPSHOT"] = "MPA_OPERATION_SCOPE_SNAPSHOT";
    MPAOperationScope["MPA_OPERATION_SCOPE_NONE"] = "MPA_OPERATION_SCOPE_NONE";
})(MPAOperationScope || (MPAOperationScope = {}));
